import { BarChart3 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { EntityConfig } from '../types';

export interface MasterProficiencyLevel {
  id: string;
  code: string;
  display_name: string;
  description: string | null;
  level_value: number;
  is_active: boolean;
  sort_order: number;
  created_at: string;
}

export const masterProficiencyLevelsConfig: EntityConfig<MasterProficiencyLevel> = {
  name: 'masterProficiencyLevels',
  singularName: 'Level',
  pluralName: 'Proficiency Levels',
  tableName: 'master_proficiency_levels',
  keyField: 'id',
  icon: <BarChart3 className="h-4 w-4" />,
  description: 'Skill proficiency levels',
  category: 'master',
  permissionModule: 'settings',

  columns: [
    {
      id: 'sort_order',
      header: 'Order',
      accessorKey: 'sort_order',
      sortable: true,
      width: '80px',
    },
    {
      id: 'code',
      header: 'Code',
      accessorKey: 'code',
      sortable: true,
      cell: (row) => <span className="font-mono text-sm">{row.code}</span>,
    },
    {
      id: 'display_name',
      header: 'Display Name',
      accessorKey: 'display_name',
      sortable: true,
    },
    {
      id: 'level_value',
      header: 'Level',
      accessorKey: 'level_value',
      cell: (row) => (
        <Badge variant="outline">{row.level_value}</Badge>
      ),
    },
    {
      id: 'description',
      header: 'Description',
      accessorKey: 'description',
      cell: (row) => row.description || <span className="text-muted-foreground">-</span>,
    },
    {
      id: 'is_active',
      header: 'Status',
      accessorKey: 'is_active',
      width: '100px',
      cell: (row) => (
        <Badge variant={row.is_active ? 'default' : 'secondary'}>
          {row.is_active ? 'Active' : 'Inactive'}
        </Badge>
      ),
    },
  ],

  formFields: [
    {
      name: 'code',
      label: 'Code',
      type: 'text',
      required: true,
      placeholder: 'e.g., beginner',
    },
    {
      name: 'display_name',
      label: 'Display Name',
      type: 'text',
      required: true,
      placeholder: 'e.g., Beginner',
    },
    {
      name: 'level_value',
      label: 'Level Value',
      type: 'number',
      required: true,
      defaultValue: 0,
      helpText: 'Numeric value for sorting/comparison',
    },
    {
      name: 'description',
      label: 'Description',
      type: 'textarea',
      gridSpan: 2,
    },
    {
      name: 'sort_order',
      label: 'Sort Order',
      type: 'number',
      defaultValue: 0,
    },
    {
      name: 'is_active',
      label: 'Active',
      type: 'switch',
      defaultValue: true,
    },
  ],

  searchFields: ['code', 'display_name'],
  defaultOrderBy: { field: 'sort_order', ascending: true },

  features: {
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canBulkDelete: false,
    showActivityLog: false,
  },
};
